<router-outlet></router-outlet>
<router-outlet name="lightbox"></router-outlet>
<mb-press-kit
  [pressKit]="pressKit"
  [defaultActions]="defaultActions"
  [sectionActions]="sectionActions"
  [pressKitActions]="pressKitActions"
></mb-press-kit>
